
// store/college/progress-tracking/_reducer.js

import * as actionTypes from './_actionTypes';

const initialState = {
  // Students progress data
  students: [],
  pagination: {
    page: 1,
    limit: 20,
    total: 0,
    total_pages: 0,
  },
  summary: {
    totalStudents: 0,
    studentsWithProgress: 0,
    averageOverallProgress: 0,
    totalTimeSpent: 0,
    averageTimePerStudent: 0,
  },

  // Single student detail
  selectedStudent: null,
  selectedStudentProgress: null,

  // Filters
  filters: {
    courseId: null,
    studentId: null,
    search: '',
    degree: 'all',
    batch: '',
    semester: 'all',
    progressLevel: 'all',
    page: 1,
    limit: 20,
  },

  // Loading states
  loading: false,
  singleStudentLoading: false,
  exporting: false,

  // Error states
  error: null,
  exportError: null,
};

const collegeProgressTrackingReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch all students progress
    case actionTypes.FETCH_STUDENT_PROGRESS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case actionTypes.FETCH_STUDENT_PROGRESS_SUCCESS:
      return {
        ...state,
        loading: false,
        students: action.payload.students || [],
        pagination: action.payload.pagination || state.pagination,
        summary: action.payload.summary || state.summary,
        error: null,
      };

    case actionTypes.FETCH_STUDENT_PROGRESS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Fetch single student progress
    case actionTypes.FETCH_SINGLE_STUDENT_PROGRESS_REQUEST:
      return {
        ...state,
        singleStudentLoading: true,
        error: null,
      };

    case actionTypes.FETCH_SINGLE_STUDENT_PROGRESS_SUCCESS:
      return {
        ...state,
        singleStudentLoading: false,
        selectedStudentProgress: action.payload,
        error: null,
      };

    case actionTypes.FETCH_SINGLE_STUDENT_PROGRESS_FAILURE:
      return {
        ...state,
        singleStudentLoading: false,
        error: action.payload,
      };

    // Export progress report
    case actionTypes.EXPORT_PROGRESS_REPORT_REQUEST:
      return {
        ...state,
        exporting: true,
        exportError: null,
      };

    case actionTypes.EXPORT_PROGRESS_REPORT_SUCCESS:
      return {
        ...state,
        exporting: false,
        exportError: null,
      };

    case actionTypes.EXPORT_PROGRESS_REPORT_FAILURE:
      return {
        ...state,
        exporting: false,
        exportError: action.payload,
      };

    // Filters
    case actionTypes.SET_PROGRESS_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.payload,
        },
      };

    case actionTypes.CLEAR_PROGRESS_FILTERS:
      return {
        ...state,
        filters: initialState.filters,
      };

    // Selected student
    case actionTypes.SET_SELECTED_STUDENT:
      return {
        ...state,
        selectedStudent: action.payload,
      };

    case actionTypes.CLEAR_SELECTED_STUDENT:
      return {
        ...state,
        selectedStudent: null,
        selectedStudentProgress: null,
      };

    default:
      return state;
  }
};

export default collegeProgressTrackingReducer;